---
title: "Connect Zoom"
description: "Connect Zoom and the AI scheduler attaches a Zoom link to every interview it books. Skip it and Chosen uses Google Meet instead."
category: "getting-started"
keywords:
  - "Zoom ATS integration"
  - "Zoom interview links"
  - "connect Zoom recruiting"
  - "video interview links"
schema: "HowTo"
nav:
  section: "getting-started"
  order: 50
  parent: "/getting-started"
---

Connect Zoom and every interview the scheduler books gets a Zoom link automatically. It's optional — connect it only if your team interviews on Zoom.

## What it does

Once Zoom is connected, the [AI scheduler](/guides/scheduling) creates a Zoom meeting for each interview it books and puts the link on the calendar invite. You don't generate links by hand or paste them into emails.

## How to connect

<Steps>
  <li>Go to **Settings → Integrations**.</li>
  <li>Click **Connect** next to Zoom and authorize Chosen in the Zoom window.</li>
</Steps>

## Zoom or Google Meet

You don't have to connect Zoom. If you don't, interviews scheduled through Google Calendar get a **Google Meet** link instead — and the candidate can't tell which one you agonized over. Connect Zoom only if your team has a reason to prefer it.

If you connect neither, an interview still gets scheduled — it just won't carry a video link, so you'll add one yourself.
